export const CHECKOUT_URL =
  'https://el-sistema-para-wedding-planners.impultienda.ar/checkout'
export const PRICE = '$19'
export const ANCHOR_PRICE = '$68'
export const SAVINGS = '$49'
export const TOTAL_VALUE = '$276'
export const SUPPORT_EMAIL = 'support@theweddingproos.com'
export const INSTAGRAM = '@theweddingproos'
